import styled from "styled-components";

export const ValidaTurnoCard = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: var(--color-latex30);
  color: var(--color-white);
  height: 74px;
  position: relative;
  div {
    display: flex;
    flex-direction: column;
  }
  .resumencard-corazonIcon {
    z-index: 10;
  }
  .text {
    width: 400px;
    font-weight: 400;
    text-transform: uppercase;
    font-size: ${({ $isTerminal }) => ($isTerminal ? "18px" : "14px")};
    line-height: 155%;
    z-index: 10;
  }
  .number {
    font-weight: 500;
    font-size: ${({ $isTerminal }) => ($isTerminal ? "18px" : "16px")};
    line-height: 150%;
    z-index: 10;
  }

  ::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 20px;
    left: 0;
    bottom: -10px;
    z-index: -10;
    border-radius: 50%;
    background-color: var(--color-latex30);
  }
  @media (max-width: 768px) {
    .text {
      width: 190px;
    }
  }
`;
